const paths = {
    HOME : '/',
    SKILLS : '/skills',
    PROJECTS : '/projects',
    CONTACT : '/contact',
    CV : '/pdf/Erika_ANDRE_DO_BRITO.pdf',
    QUAI_ANTIQUE: '/projects/quai-antique',
    CHARLES_CANTIN: '/projects/charles-cantin',
    DES_AVENTURES : '/projects/dés-aventures',
    ROLLIN_BATTLE : '/projects/rollin-battle',
    MEMORY : '/projects/memory',
    MLP : '/projects/my-little-pony',
    CODEPEN : '/projects/codepen'
}

export default paths;